module.exports = __webpack_public_path__ + "img/gszz2@2x.2cee33e0.png";